<template>
  <div class="joulesControl">
    <v-text-field
        v-model="textValue"
        :type="aedEnabled ? 'text' : 'number'"
        hide-details
        outlined
        dense
        :readonly="aedEnabled"
    >
      <template v-slot:append-outer>
        <v-checkbox
            v-model="aedEnabled"
            label="AED"
            class="aedCheckbox mt-0"
            hide-details
            dense
        />
      </template>
    </v-text-field>
  </div>
</template>
<script>
export default {
  name: 'Joules',
  props: {
    value: {
      type: String,
    },
  },

  computed: {
    aedEnabled: {
      get() {
        return this.value && this.value === 'AED';
      },
      set(value) {
        if (value) {
          this.textValue = 'AED';
        } else {
          this.textValue = null;
        }
      },
    },
    textValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
<style lang="scss">
.joulesControl {
  .v-input__append-outer {
    margin-top: 5px !important;
  }
  .aedCheckbox label {
    top: 0px !important;
  }
}
</style>
